<template>
  <svg width="55" height="30" viewBox="0 0 65 30" fill="none" style="margin-top: 5px; margin-right: -5px; cursor: pointer" @click="click">
    <rect x="0.5" y="0.5" width="64" height="29" rx="9.5" :fill="isDarkMode ? '#222222' : 'white'" />
    <path
      d="M14.19 9.626V11.124H18.404C18.068 13.98 16.472 16.024 13.476 17.564L14.512 18.978C18.796 16.808 20.266 13.49 20.266 9.626H14.19ZM25.502 13.224H23.696V8.296H21.848V21.176H23.696V14.75H25.502V13.224ZM35.3149 8.296V21.232H37.1629V8.296H35.3149ZM30.2329 9.206C28.2869 9.206 26.8449 10.97 26.8449 13.798C26.8449 16.64 28.2869 18.418 30.2329 18.418C32.1789 18.418 33.6209 16.64 33.6209 13.798C33.6209 10.97 32.1789 9.206 30.2329 9.206ZM30.2329 10.872C31.1849 10.872 31.8429 11.894 31.8429 13.798C31.8429 15.716 31.1849 16.738 30.2329 16.738C29.2809 16.738 28.6229 15.716 28.6229 13.798C28.6229 11.894 29.2809 10.872 30.2329 10.872ZM49.7898 14.26H42.5658V10.872H49.6918V9.374H40.7178V15.73H49.7898V14.26ZM39.3598 18.152V19.664H51.0358V18.152H39.3598Z"
      fill="#3CAEA3"
    />
    <rect x="0.5" y="0.5" width="64" height="29" rx="9.5" stroke="#3CAEA3" />
  </svg>
</template>

<script>
export default {
  props: ["isDarkMode"],
  methods: {
    click() {
      gtag("event", "click-guide")
      window.open("/news/tip")
    }
  }
}
</script>

<style></style>
